import { Component } from "preact";
import { open, setLink } from "../../state/actions/shareActions";
import { connect } from "react-redux";
import { css } from "emotion";

const icon = require("../../assets/share/ic_share.svg");

const styling = css({
  width: 30,
  height: 30,
  border: "none",
  padding: 0,
  background: "none",
  "&:hover": { cursor: "pointer" },
  img: {
    width: "30px !important",
    height: 30
  }
});

class ShareButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { open, setLink, link } = this.props;
    return (
      <button
        onClick={() => {
          setLink(link);
          open();
        }}
        className={styling}
      >
        <img src={icon} />
      </button>
    );
  }
}

export default connect((state, ownProps) => ({}), {
  open,
  setLink
})(ShareButton);
